import { EmptystateLinkColored } from "components/icons/generated";
import CardCollapsible from "ds/components/Card/Collapsible";
import useAutoExpandOnValueChange from "ds/components/Card/Collapsible/useAutoExpandOnValueChange";
import Counter from "ds/components/Counter";
import EmptyState from "ds/components/EmptyState";
import { useToggle } from "hooks/useToggle";

import NewModuleAttachedPolicy from "../AttachedPolicy";
import { AttachedPolicy } from "../types";

type NewModuleManuallyAttachedPoliciesProps = {
  items: AttachedPolicy[];
};

const NewModuleManuallyAttachedPolicies = ({ items }: NewModuleManuallyAttachedPoliciesProps) => {
  const [isCollapsed, toggle] = useToggle(true);

  useAutoExpandOnValueChange(items.length, toggle);

  return (
    <CardCollapsible
      ariaLevel={3}
      ariaLabel="Attached directly"
      title="Attached directly"
      isCollapsed={isCollapsed}
      onToggle={toggle}
      titleSuffix={<Counter count={items.length} />}
      contentGap="medium"
    >
      {items.length === 0 ? (
        <EmptyState
          padding="large"
          icon={EmptystateLinkColored}
          title="No policies are attached to this module"
          caption="Use policies list to attach a policy to module."
        />
      ) : (
        <>
          {items.map((item) => (
            <NewModuleAttachedPolicy key={item.id} item={item} headingLevel={4} />
          ))}
        </>
      )}
    </CardCollapsible>
  );
};

export default NewModuleManuallyAttachedPolicies;
